
export default {
  name: 'NotificationFloatingWrapper'
}
